/*=========================================================================================
  File Name: getters.js
  namespace: passes
  Description: Vuex Store - Pass getters
==========================================================================================*/
import {
  buildPassState
} from './state'

const getters = {
  getCurrentPass: state => {
    return state.currentPass
  },
  getNewPass: () => {
    return buildPassState()
  },
  getPassList: state => {
    return {
      results: state.results,
      count: state.count
    }
  },
  getPassEntries: state => {
    return state.passList
  }
}

export default getters
